import { css } from "styled-system/css";
import { normalizePrimary } from "@/components/book/book-public-layout";

export type BookTabId = "reservar" | "info";

type Props = {
  active: BookTabId;
  onChange: (tab: BookTabId) => void;
  primaryColor: string;
};

const TABS: { id: BookTabId; label: string }[] = [
  { id: "reservar", label: "Reservar" },
  { id: "info", label: "Info" },
];

export function BookTabs({ active, onChange, primaryColor }: Props) {
  const accent = normalizePrimary(primaryColor);
  return (
    <div
      role="tablist"
      className={css({
        display: "flex",
        gap: "1",
        mb: "6",
        borderBottomWidth: "1px",
        borderColor: "var(--pp-border)",
      })}
    >
      {TABS.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={css({
              px: "4",
              py: "2.5",
              mb: "-1px",
              fontSize: "sm",
              fontWeight: "semibold",
              bg: "transparent",
              border: "none",
              borderBottomWidth: "2px",
              cursor: "pointer",
              transition: "color 160ms ease-out, border-color 160ms ease-out",
            })}
            style={{
              color: isActive ? "var(--pp-text)" : "var(--pp-muted)",
              borderBottomColor: isActive ? accent : "transparent",
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
